import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { navigateInBaseModal } from '../../app/actions/common';

export const navigateToResourceStatusReport =
    (): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const state = getState();
        const serviceId = getSelectedServiceId(state);
        const url = resolveRoute(RouteName.ResourceStatusReportIndex, { query: { 'Service.Id': serviceId } });
        dispatch(navigateInBaseModal(url));
    };
